<template>
    <div v-if="invoice.invoice_id">
        <ViewSale2 :viewdata="invoice" />
    </div>
</template>

<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import ViewSale2 from "@/components/Sales/ViewSale2"

    export default {
        name: "ViewSaleWrapper",
        props: [],
        components: {ViewSale2},
        data: function(){
            return {
                invoice_id: null,
                invoice: {},
                message: null
            }
        },
        methods: {
            fetch_init: function(e){
                if (e){
                    e.preventDefault()
                }
                let path = "/api/sales/get_invoice/"
                let data = {invoice_id: this.invoice_id}
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        that.invoice = response.data.result

                        if (!that.invoice.invoice_id){
                            that.message = "No invoice found."
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.invoice_being_loaded = false;
                }
                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading invoice. Please try again later.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.invoice_being_loaded = false;
                }
                this.invoice_being_loaded=true;
                Requestor.postAsyncP(path, data, this, s, f);
            }
        },
        created: function(){
            this.invoice_id = this.$route.params.invoice_id;
            this.fetch_init()
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Sales/ViewSaleWrapper.vue